var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-button-area"},[_c('div',{staticClass:"icon-caret-left back-button-icon mr-1"}),_c('div',{staticClass:"back-button",on:{"click":_vm.gotoPage}},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }